
import React, { useContext } from "react";
import i18next from "i18next";
import { Grid } from "@mui/material";
import RuleSelectInput from "components/rules/RuleSelectInput";
import { RuleActionParameterNames, RulesContext } from "services/common/RulesUtils";
import { dossiersTypesCodeToIgnore } from "services/common/Constants";


const DossierStopActionParams = ({ fieldName, readOnly = false }) => {
  const {
    dossierTypes,
  } = useContext(RulesContext);

  const mappedDossierTypes = dossierTypes?.map(({ code, label }) => ({
    value: code !== "null" ? code : 'FREE',
    label
  }));

  return (
    <Grid container spacing={2} style={{ alignItems: "center", justifyContent: "center" }}>
      <Grid item xs={12} md={6}>
        <RuleSelectInput
          fieldName={`${fieldName}.${RuleActionParameterNames.DOSSIER_TYPE_CODE}`}
          label={`${i18next.t("rules.configuration.ruleActions.fields.parameters.dossierTypeCode.label")}`}
          placeholder={i18next.t(`rules.configuration.ruleActions.fields.parameters.dossierTypeCode.placeholder`)}
          options={mappedDossierTypes?.filter(
            (dossierType) =>
              !dossiersTypesCodeToIgnore.includes(dossierType.value)
          )}
          onChange={() => { }}
          isRequired
          validate={() => { return null;}}
          labelVariant='chip'
          disabled={readOnly}
        />
      </Grid>
    </Grid >
  );
}

export default DossierStopActionParams;
